// Rete di sicurezza per gli errori dell'interfaccia.
//
// Senza questo, un errore in un qualsiasi componente smonta tutta l'app e
// lascia una pagina bianca: per chi la usa e' indistinguibile da "l'app non
// funziona", e non resta traccia di cosa sia successo.

import React from 'react';
import { Button } from 'antd';
import { segnalaErrore } from '../monitoraggio';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { errore: null };
    }

    static getDerivedStateFromError(errore) {
        return { errore };
    }

    componentDidCatch(errore, info) {
        // Resta nei log del dispositivo, recuperabile in fase di assistenza.
        console.error('Errore non gestito nell\'interfaccia:', errore, info?.componentStack);
        // E viene segnalato, cosi' non serve che sia l'utente a raccontarlo.
        segnalaErrore(errore, info);
    }

    render() {
        if (!this.state.errore) return this.props.children;

        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '32px 24px',
                textAlign: 'center',
                background: 'var(--sfondo)',
            }}>
                <h1 style={{ fontSize: 22, margin: '0 0 12px', color: 'var(--inchiostro)' }}>
                    Qualcosa è andato storto
                </h1>
                <p style={{ fontSize: 16, color: 'var(--testo)', margin: '0 0 28px', maxWidth: 340 }}>
                    Questa schermata non si è caricata correttamente. Riprova: se succede di
                    nuovo, segnalalo al tuo personal trainer.
                </p>
                <Button
                    type="primary"
                    size="large"
                    style={{ background: 'var(--primario)', borderColor: 'var(--primario)', minWidth: 200, height: 48 }}
                    onClick={() => window.location.reload()}
                >
                    Ricarica l'app
                </Button>
            </div>
        );
    }
}

export default ErrorBoundary;
